export default __webpack_public_path__ + "static/media/graphic-10.98d1f454.png";